import React, { useContext } from 'react';
import { OperationType } from './types/SelectedOperation';
import { QaErrorsContext } from './QaErrorsProvider';
import { ConfigModal } from './modals/ConfigModal';

export const SelectedOperationActions: React.FC = () => {
  const { selectedOperation, setSelectedOperation } = useContext(QaErrorsContext);
  const closeModal = () => setSelectedOperation(null);

  switch (selectedOperation?.type) {
    case OperationType.ConfigScript:
      return (
        <ConfigModal
          visible={true}
          qaError={selectedOperation.qaError}
          onComplete={selectedOperation.onComplete}
          onClose={closeModal}
        />
      );
  }

  return null;
};
